module.exports = {
    refreshKlarna() {
        if (!window.KlarnaOnsiteService) window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
        if (window.KlarnaOnsiteService) window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    },

    refreshShopRunner(subTotalValue) {
        if (typeof _shoprunner_com !== 'undefined') {
            _shoprunner_com.cart = {};
            _shoprunner_com.cart.srSubTotal = subTotalValue;
            if (typeof window.sr_$ !== 'undefined') {
                try {
                    window.sr_updateMessages();
                } catch (e) {}
            }
        }
    },

    refreshMiniCart(count) {
        document.dispatchEvent(new CustomEvent('update-minicart-quantity', { detail: count }));
    },

    createError(errorMessage) {
        if (errorMessage) {
            document.dispatchEvent(new CustomEvent('create-error-notification', { detail: { errorMessage } }));
        }
    },

    spinner: {
        start() {
            document.dispatchEvent(new Event('start-spinner'));
        },

        stop() {
            document.dispatchEvent(new Event('stop-spinner'));
        }
    }
};
